import {isDesktop} from "./devices";
import PinchZoom from "pinch-zoom-js";
import Splide from "@splidejs/splide";
import {getImageSizeFromUrl} from "./image";
import {hideElement, showElement} from "./element-visibility";
import EmblaCarousel from "embla-carousel";

const $body = document.querySelector('body');
const $html = document.querySelector('html');
let scrollPosition = 0;

export function addIOSWindowFix()
{
    $html.style.height = 'calc(100vh - 1px)';
    scrollPosition = window.pageYOffset;
    $body.style.overflowY = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = `-${scrollPosition}px`;
    $body.style.width = '100%';
}

export function clearIOSWindowFix()
{
    $body.style.removeProperty('overflowY');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
    $html.style.removeProperty('height');
}

export function loadMobileZoom(modal, embla)
{
    if (!isDesktop()) {
        let images = modal.querySelectorAll('.main-slider .touch-zoom');
        let navigationTimeout;
        images.forEach(function(image) {
            new PinchZoom(image, {
                onZoomStart: function(object) {
                    embla.reInit({watchDrag: false});
                },
                onZoomUpdate: function(object) {
                    embla.reInit({watchDrag: false});
                    clearTimeout(navigationTimeout);
                    navigationTimeout = setTimeout(function() {
                        let allowNavigation = object.zoomFactor === 1;
                        embla.reInit({watchDrag: allowNavigation});
                    }, object.options.animationDuration+150);
                },
                draggableUnzoomed: false
            });
        });
    }
}

export function loadImageSlider(modal, embla)
{
    embla = loadMainSlider(modal.id);
    loadThumbnailSlider(modal.id, embla);

    return embla;
}

function loadMainSlider(modalId)
{
    let slider = document.querySelector(`#${modalId} .main-slider`);
    let emblaPrevButton = slider.querySelector('.embla-prev-button');
    let emblaNextButton = slider.querySelector('.embla-next-button');

    let emblaMainSlider = EmblaCarousel(slider.querySelector('.embla-carousel'));

    //BUTTONS FUNCTIONALITY
    if (emblaMainSlider.canScrollPrev()) emblaPrevButton.classList.remove('d-none');
    if (emblaMainSlider.canScrollNext()) emblaNextButton.classList.remove('d-none');

    emblaPrevButton.addEventListener('click', emblaMainSlider.scrollPrev, false);
    emblaNextButton.addEventListener('click', emblaMainSlider.scrollNext, false);

    emblaMainSlider.on('select', function() {
        if (emblaMainSlider.canScrollPrev() && emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.remove('d-none');
        if (!emblaMainSlider.canScrollPrev() && !emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.add('d-none');
        if (emblaMainSlider.canScrollNext() && emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.remove('d-none');
        if (!emblaMainSlider.canScrollNext() && !emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.add('d-none');
    });

    return emblaMainSlider;
}

function loadThumbnailSlider(modalId, emblaMainSlider)
{
    let slider = document.querySelector(`#${modalId} .thumbnail-slider`);
    let thumbnails = slider.querySelectorAll('.embla-slide');
    let emblaThumbnailSlider = EmblaCarousel(slider, {slidesToScroll: 'auto', dragFree: true});

    emblaMainSlider.on('init', function() {
        thumbnails[emblaMainSlider.selectedScrollSnap()].classList.add('active');
    });

    emblaMainSlider.on('select', function() {
        let index = emblaMainSlider.selectedScrollSnap();

        emblaThumbnailSlider.scrollTo(index);
        thumbnails.forEach((thumbnail) => thumbnail.classList.remove('active'));
        thumbnails[index].classList.add('active');
    });

    thumbnails.forEach(function(thumbnail, index) {
        thumbnail.addEventListener('click', function() {
            emblaMainSlider.scrollTo(index);
            thumbnails.forEach((thumbnail) => thumbnail.classList.remove('active'));
            thumbnails[index].classList.add('active');
        });
    });
}

export function removeZoomOfAllDesktopImages(modal)
{
    let images = modal.querySelectorAll('.main-slider .desktop-zoom');
    images.forEach(function(image) {
        zoomImage(image, false);
    });
}

export function zoomImage(element, isZoomed, enableMargins = true)
{
    let image = element.querySelector('img');
    let parent = element.closest('.embla-slide');
    let slider = element.closest('.embla-carousel');
    getImageSizeFromUrl(image.src, function (width, height) {
        let margin = 0;
        let marginWidth = 0;
        let marginHeight = 0;
        if (enableMargins) {
            margin = 50;
            marginWidth = 20;
            marginHeight = 10;
        }

        let minWidth = slider.offsetWidth + margin;
        let minHeight = slider.offsetHeight + margin;
        if (width <= minWidth && height <= minHeight) element.style.backgroundSize = 'cover';
        if (isZoomed) {
            element.style.width = parent.offsetWidth - marginWidth + "px";
            element.style.height = parent.offsetHeight - marginHeight + "px";
            element.classList.add('zoomed');
            element.style.backgroundImage = `url('${image.src}')`;
            hideElement(image);
            element.onmousemove = (event) => {
                moveImage(event)
            };
        } else {
            element.classList.remove('zoomed');
            element.style.width = '';
            element.style.height = '';
            element.style.backgroundImage = '';
            showElement(image);
        }
    });
}

export function moveImage(e)
{
    let imageZoom = e.currentTarget;
    let offsetX = e.offsetX || null;
    let offsetY = e.offsetY || null;
    if (!offsetX || !offsetY) return;
    let x = offsetX/imageZoom.offsetWidth * 100;
    let y = offsetY/imageZoom.offsetHeight * 100;
    imageZoom.style.backgroundPosition = x + '% ' + y + '%';
}